import React from 'react'
import Editingpage from '../components/Editingpage/Editingpage'

function Editing() {
  return (
    <div>
        <Editingpage/>
      
    </div>
  )
}

export default Editing
